import * as React from 'react';
import * as CheckboxPrimitive from '@radix-ui/react-checkbox';
import { CheckIcon } from 'lucide-react';
import { cn } from '@noor/lib/cn';

function Checkbox({
  className,
  ...props
}: React.ComponentProps<typeof CheckboxPrimitive.Root>) {
  return (
    <CheckboxPrimitive.Root
      data-slot="checkbox"
      className={cn(
        // Figma box: 20px, 6px radius, #d0d5dd border; checked fills brand
        // orange with a white 14px check. Disabled softens the border to
        // #e4e7ec and (when checked) shows a dark check on white.
        // Box metrics resolve through `--checkbox-*` sizing handles.
        'peer h-[var(--checkbox-size)] w-[var(--checkbox-size)] shrink-0 rounded-[var(--checkbox-radius)] border border-control-border bg-card transition-shadow outline-none',
        'focus-visible:border-control-ring focus-visible:ring-control-ring/50 focus-visible:ring-[3px]',
        'data-[state=checked]:border-control-bg-checked data-[state=checked]:bg-control-bg-checked data-[state=checked]:text-control-fg-checked',
        'aria-invalid:border-input-border-invalid aria-invalid:ring-input-border-invalid/20',
        'disabled:cursor-not-allowed disabled:border-form-control-border-soft disabled:data-[state=checked]:bg-card disabled:data-[state=checked]:text-form-label-fg',
        className,
      )}
      {...props}
    >
      <CheckboxPrimitive.Indicator
        data-slot="checkbox-indicator"
        className="flex items-center justify-center text-current transition-none"
      >
        <CheckIcon className="size-3.5" />
      </CheckboxPrimitive.Indicator>
    </CheckboxPrimitive.Root>
  );
}

export { Checkbox };
